<template>
	<div class="purchase_service" v-if="detail">
		<div class="order_status">
			<h3
				class="label"
				>{{ $status.orderStatus[detail.detectStatus] }}</h3
			>
			<p class="desc" v-if="detail.detectStatus == 99">超时未支付</p>
			<p class="desc" v-if="detail.detectStatus == 2"
				>请耐心等待检测报告上传</p
			>
			<p class="desc" v-if="detail.detectStatus == 1"
				>请联系医生助手完成疾病检测，并耐心等待送检</p
			>
			<p class="desc" v-if="detail.detectStatus == 0"
				>剩余支付时间
				<van-count-down
					class="text-danger"
					:time="downCountTime"
					format="HH时mm分ss秒"
					@finish="getDetail"
				/>
			</p>
		</div>
		<!--检测人信息-->
		<base-card title="检测人信息" title-icon="infor.png">
			<van-cell class="form-item" title="真实姓名"
				>{{ detail.patientName }} {{ detail.patientGender }}
				{{ detail.patientAge }}岁</van-cell
			>
			<van-cell
				class="form-item"
				title="身份证号"
				>{{ detail.patientIdcard }}</van-cell
			>
		</base-card>

		<!--检测中心-->
		<base-card
			class="mt-28"
			:title="detail.organName"
			title-icon="institution.png"
			title-icon-width="23"
		>
			<infor-card
				:list="getListDataFormat"
				:total-price="detail.totalPrice"
				:sample-type="getSampleType"
				:total-info="{
					totalNum: `共${ (detail.productList || []).length}件`,
					totalPrice: getProductTotalPrice
				}"
			></infor-card>
		</base-card>

		<!-- 报告解读 -->
		<export-parse :detail="detail" disabled></export-parse>

		<!--订单信息0: '待支付',1: '送检中',2: '检测中',3: '已完成',4: '待送检',99: '交易关闭'-->
		<base-card title="订单信息" class="mt-28">
			<text-item label="支付方式" v-if="detail.detectStatus != 0"
				>微信支付</text-item
			>
			<text-item
				label="支付时间"
				class="mt-32"
				v-if="detail.detectStatus != 0"
				>{{ detail.payTime }}</text-item
			>
			<text-item
				label="订单编号"
				class="mt-32"
				>{{ detail.number }}</text-item
			>
			<text-item
				label="创建时间"
				class="mt-32"
				>{{ detail.createTime }}</text-item
			>
		</base-card>

		<foot-button v-if="detail.detectStatus == 0"
			><van-button type="primary" block @click="clickPay"
				>立即支付</van-button
			></foot-button
		>
		<!-- <foot-button v-if="detail.detectStatus == 3">
			<van-button type="primary" block @click="$router.push(`/report/view-report/${ detail.id }`)">
				查看报告
			</van-button>
		</foot-button> -->
		<foot-button v-if="detail.detectStatus != 0&&detail.detectStatus != 99">
			<!-- 发票---0: "未申请",1: "已申请",2: "已开具", v-if="detail.detectInvoiceDTO&&detail.detectInvoiceDTO.status"-->
			<van-button
				type="primary"
				plain
				block
				@click="clickInvoice"
				:disabled="detail.detectInvoiceDTO&&detail.detectInvoiceDTO.status==1?true:false"
			>
				{{detail.detectInvoiceDTO&&detail.detectInvoiceDTO.status==2?'查看发票':detail.detectInvoiceDTO&&detail.detectInvoiceDTO.status==1?'发票开具中':'开具发票'}}
			</van-button>
			<van-button
				v-if="detail.detectStatus == 3"
				type="primary"
				block
				@click="$router.push(`/report/view-report/${ detail.id }`)"
			>
				查看报告
			</van-button>
		</foot-button>
	</div>
</template>

<script>
	 import ExportParse from '../purchase/components/reportParse.vue'
	export default {
		name: 'PurchaseService',
	   components: { ExportParse },
		data: () => ({
			detail: null
		}),
		computed: {
			downCountTime () {
				const totalTime = 12 * 60 * 60 * 1000
				if (!this.detail) return totalTime
				const createTime = this.$moment(this.detail.createTime).format('x')
				return totalTime - (this.$store.state.account.serveDateTime - createTime)
			},
			getListDataFormat () {
				if (!this.detail) return []
				return (this.detail.productList || []).map(item => ({
					...item,
					title: item.productName,
					content: (item.itemList || []).map(val => val.itemName).join('、'),
					desc: [{ label: `￥${ item.totalPrice }`, value: `x${ item.quantity }` }]
				}))
			},
			getProductTotalPrice () {
				if (!this.detail) return 0
				return (this.detail.productList || []).reduce((v, d) => (v + d.totalPrice), 0)
			},
			getSampleType () {
				if (!this.detail) return ''
				return (this.detail.detectType || '').split('&').map(item => (this.$store.state.account.detectType[item])).join('+')
			}
		},
		created () {
			this.getDetail()
		},
		methods: {
			async getDetail () {
				const res = await this.$api.order.detail(this.$route.params.id)
				if (!res.code) {
					this.detail = res.data
					if (res.data.detectStatus == 0) {
						await this.$store.dispatch('account/actionGetDateTime')
					}
				}
			},
			// 点击立即购买
			clickPay () {
				this.$wx.wxPay({
          appId: this.$config.appid,
					idCard: this.detail.patientIdcard,
					name: this.detail.patientName,
					openId: this.$store.getters['account/getOpenid'],
					orderId: this.$route.params.id,
	        callBackUrl: window.location.origin
	           + `/static/pay-result/index.html?url=`
	           + decodeURIComponent(`${this.$route.path}`)
	           + `&err=`
	           + decodeURIComponent(`${this.$route.path}`)
	           + `&orderId=${this.$route.params.id}`
				}, (res) => {
	        window.location.href = res.data.webPayUrl;
					// this.getDetail()
				})
			},
			clickInvoice(){
				let status = this.detail.detectInvoiceDTO&&this.detail.detectInvoiceDTO.status
				if(status===2){
					window.location.href = this.detail.detectInvoiceDTO.invoiceUrl
				}else{
					this.$router.push(`/order/invoicing/${this.detail.id}`)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.purchase_service {
		padding: 32px;
		min-height: calc(100vh - 216px);
		.order_status {
			padding-bottom: 40px;
			.label {
				font-family: PingFangSC-Semibold;
				font-size: 46px;
				font-weight: normal;
				line-height: 50px;
				color: #333;
			}
			.desc {
				display: flex;
				align-items: center;
				margin-top: 20px;
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: #646A73;
			}
		}
	}
</style>

<style lang="less">
	.purchase_service {
		.van-cell__title { flex: 0 0 160px; }
		.van-cell__value { flex: auto; }
	}
</style>
